// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price[data-v-3d5a9145]{color:#979797;font-weight:400}.small[data-v-3d5a9145]{font-size:1.2rem}.medium[data-v-3d5a9145]{font-size:1.4rem}.large[data-v-3d5a9145]{font-size:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
